import api from "src/apis/api"

// ── Fetch duplicate clusters ──────────────────────────────────────────────────
// Returns grouped clusters of leads that share a phone/email, each with the
// distinct source channels the buyer reached us through.
//   { clusters: [{ key, size, sources, suggested_primary_id, leads: [...] }], meta }
export async function fetchDuplicateClusters() {
  const { data } = await api.get("/api/v1/leads/duplicates")
  return data
}

// ── Merge ─────────────────────────────────────────────────────────────────────
// Folds `duplicateIds` into `primaryId`. Returns the surviving primary lead
// (with unioned sources) and the ids that were merged away.
export async function mergeLeads({ primaryId, duplicateIds }) {
  const { data } = await api.post("/api/v1/leads/duplicates/merge", {
    primary_id:    primaryId,
    duplicate_ids: duplicateIds,
  })
  return data
}
